import React, { useRef, useEffect, useState } from 'react';
import { Dialog, DialogContent } from '@material-ui/core';
import { useGlobal } from '@rcg/ui-react';
import PropTypes from 'prop-types';
import { createCookie, setSessionStorageItem, getCookies } from '../../utils/common';
import { loyaltyDataVar } from '../../operations/localState/reactiveVariables';
import {
  COOKIE_KEYS,
  SESSION_STORAGE_GUEST_ACCOUNT_CREATION,
  SESSION_STORAGE_GUEST_ACCOUNT_LOGGED,
} from '../../utils/constants';
import useStyles from './index.style';
import useLiteProfile from '../../operations/dataAccess/useLiteProfile';

const SignInModal = (props) => {
  const defaultProps = { ...props, closeAfterTransition: true };
  const { closeModal, setLoginModal, open, children, setProfileAccessToken, isCelebrityBrand } =
    props;

  const globalLogin = useRef(null);
  const css = useStyles();
  const {
    data: { lang },
  } = useGlobal();

  const [openModal, setOpenModal] = useState(open);
  const [environment, setEnvironment] = useState('production');

  const brand = isCelebrityBrand ? 'celebrity' : 'royal';
  const brandConvention = isCelebrityBrand ? 'CEL' : 'RCI';

  const dataLayer = {
    siteSection: 'airbooking:book a flight home',
    eventType: 'interaction',
    interaction: 'login:panel:opened',
    contentPosition: 'Header-GA-OrgranicSignIn',
    referringLinkLocation: 'airbooking:book a flight home',
    brand: brandConvention,
    siteType: 'desktop',
    language: lang,
    appName: 'Air',
  };

  const [dispatchLiteProfile, { data: liteProfileData }] = useLiteProfile({
    fetchPolicy: 'no-cache',
  });

  const handleClose = () => {
    setOpenModal(false);
  };

  useEffect(() => {
    if (process.env.REACT_APP_UNIFIED_PAYMENT_VERSION === 'test') {
      if (brand === 'celebrity') {
        setEnvironment('stage');
      } else {
        setEnvironment(process.env.REACT_APP_UNIFIED_PAYMENT_VERSION);
      }
    }
  }, []);

  useEffect(() => {
    setTimeout(() => {
      const handleSuccessSession = (event) => {
        createCookie({
          name: 'accessToken',
          value: event.detail.accessToken,
          time: new Date(new Date().getTime() + 3.6e6), // 1 hour
        });

        createCookie({
          name: COOKIE_KEYS.VDS_ID,
          value: event.detail.vdsId,
        });
        dispatchLiteProfile();
        handleClose();
      };

      const containerElement = globalLogin?.current;
      containerElement?.addEventListener('successSession', handleSuccessSession);

      return () => {
        containerElement?.removeEventListener('successSession', handleSuccessSession);
      };
    }, 0); // execute after global-login will be mounted in the DOM
  }, [open]);

  useEffect(() => {
    if (liteProfileData) {
      const {
        getLiteProfile: { creationDate = '', loyaltyData = {} },
      } = liteProfileData;

      if (creationDate) {
        setSessionStorageItem(SESSION_STORAGE_GUEST_ACCOUNT_CREATION, creationDate);
      }

      if (loyaltyData) {
        createCookie({
          name: COOKIE_KEYS.LOYALTY_DATA,
          value: loyaltyData,
        });
        loyaltyDataVar(loyaltyData);
        setLoginModal(false);
        setProfileAccessToken(getCookies('accessToken') || null);
        setSessionStorageItem(SESSION_STORAGE_GUEST_ACCOUNT_LOGGED, true);
      }
    }
  }, [liteProfileData]);

  return (
    <Dialog
      onClose={closeModal}
      open={openModal}
      scroll="body"
      {...defaultProps}
      maxWidth="md"
      className={css.paper}>
      <DialogContent dividers={false} className={css.MuiDialogContentRoot}>
        {children}
        <global-login
          brand={brand}
          env={environment}
          enrollment
          language={lang}
          ref={globalLogin}
          analytics-data-object={JSON.stringify(dataLayer)}
        />
      </DialogContent>
    </Dialog>
  );
};
SignInModal.propTypes = {
  open: PropTypes.bool,
  closeModal: PropTypes.func,
  setLiteProfileLoading: PropTypes.func,
  setTriggerGuestProfile: PropTypes.func,
  children: PropTypes.element,
};
export default SignInModal;
